/**
 * Downloads the file from action.url
 */

import * as actionTypes from "../actions/actionTypes";

const downloadFile = _store => next => action => {
  if (action.type === actionTypes.DOWNLOAD_FILE) {
    let iframe = document.getElementById("hiddenDownloader");
    if (!iframe) {
      iframe = document.createElement("iframe");
      iframe.id = "hiddenDownloader";
      iframe.style.visibility = "hidden";
      iframe.style.display = "none";
      iframe.style.position = "absolute";
      iframe.style.left = "-9999px";
      iframe.style.top = "-9999px";
      document.body.appendChild(iframe);
    }
    iframe.src = action.url;
  }

  return next(action);
};

export default downloadFile;
